import useCurrentMerchant from 'hooks/useCurrentMerchant'
import Cookie from 'js-cookie'
import { useEffect, useState } from 'react'

export default function useCredentialSharingNagDismissal(): [
  boolean,
  () => void
] {
  const merchant = useCurrentMerchant()
  const cookieName = merchant?.id
    ? `credential_sharing_nag_dismissed_${merchant.id}`
    : null

  const [isDismissed, setIsDismissed] = useState(() =>
    cookieName ? Cookie.get(cookieName) === 'true' : false
  )

  useEffect(() => {
    if (!cookieName) {
      setIsDismissed(false)
      return
    }
    setIsDismissed(Cookie.get(cookieName) === 'true')
  }, [cookieName])

  const dismiss = () => {
    if (!cookieName) return
    // SameSite intentionally omitted — matches auth cookie pattern;
    // modern browsers default to Lax.
    // 24h expiry (deliberately longer than the legal-docs 1h nag) — this is a
    // lower-urgency, once-per-day reminder.
    Cookie.set(cookieName, 'true', {
      expires: new Date(Date.now() + 86400000),
      path: '/',
      secure:
        process.env.NODE_ENV !== 'development' &&
        process.env.NODE_ENV !== 'test',
    })
    setIsDismissed(true)
  }

  return [isDismissed, dismiss]
}
